<template>
  <el-dialog :close-on-click-modal="false" :title="$t('chong-dian-qiang-xiang-qing')" :visible="detailFormVisible" :modal-append-to-body='false' @close="closeDetailForm">
    <el-tabs v-model="viewName">
      <el-tab-pane :label="$t('xiang-qing')" name="detailForm">
        <el-form :model="detailForm" ref="detailForm" size="mini" class="detail_form">
          <el-collapse v-model="activeNames">
            <el-collapse-item :title="$t('ji-ben-xin-xi')" name="basicInformation">
              <el-col :span="12">
                <el-form-item :label="$t('chong-dian-qiang-bian-hao')" :label-width="formLabelWidth" prop="gunCode">
                  <label v-text="detailForm.gunCode"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('chong-dian-qiang-kou-hao')" :label-width="formLabelWidth" prop="gunNum">
                  <label v-text="detailForm.gunNum"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('chong-dian-qiang-ming-cheng')" :label-width="formLabelWidth" prop="gunName">
                  <label v-text="detailForm.gunName"></label>
                </el-form-item>
              </el-col>

<!--              <el-col :span="12">-->
<!--                <el-form-item label="是否支持预约：" :label-width="formLabelWidth" prop="ableAppointment">-->
<!--                  <label v-text="detailForm.ableAppointment"></label>-->
<!--                </el-form-item>-->
<!--              </el-col>-->
<!--              <el-col :span="12">-->
<!--                <el-form-item label="预约订单号：" :label-width="formLabelWidth" prop="appointmentId">-->
<!--                  <label v-text="detailForm.appointmentId"></label>-->
<!--                </el-form-item>-->
<!--              </el-col>-->
              <el-col :span="12">
                <el-form-item :label="$t('shi-fou-suo-zhu')" :label-width="formLabelWidth" prop="gunLock">
                  <label v-if="detailForm.gunLock" v-text="detailForm.gunLock.message"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('deng-lu-ip')" :label-width="formLabelWidth" prop="commandIp">
                  <label v-text="detailForm.commandIp"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('deng-lu-duan-kou')" :label-width="formLabelWidth" prop="commandPort">
                  <label v-text="detailForm.commandPort"></label>
                </el-form-item>
              </el-col>
<!--              <el-col :span="12">-->
<!--                <el-form-item label="备注：" :label-width="formLabelWidth" prop="remark">-->
<!--                  <label v-text="detailForm.remark"></label>-->
<!--                </el-form-item>-->
<!--              </el-col>-->
            </el-collapse-item>
            <el-collapse-item :title="$t('bang-ding-xin-xi')" name="bindingInformation">
              <el-col :span="12">
                <el-form-item :label="$t('yun-ying-shang')" :label-width="formLabelWidth" prop="operatorName">
                  <label v-text="detailForm.operatorName"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('suo-shu-chang-zhan-0')" :label-width="formLabelWidth" prop="stationName">
                  <label v-text="detailForm.stationName"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('suo-shu-she-bei-0')" :label-width="formLabelWidth" prop="pileName">
                  <label v-text="detailForm.pileName"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('zhuang-lei-xing')" :label-width="formLabelWidth" prop="pileTypeName">
                  <label v-text="detailForm.pileTypeName"></label>
                </el-form-item>
              </el-col>
              <!--<el-col :span="12">
                <el-form-item label="二级运营商：" :label-width="formLabelWidth" prop="virtualId">
                  <label v-text="detailForm.virtualId"></label>
                </el-form-item>
              </el-col>-->
            </el-collapse-item>
            <el-collapse-item :title="$t('chong-dian-zhuang-tai-xin-xi')" name="chargingStatusInformation">
              <el-col :span="12">
                <el-form-item :label="$t('zhuang-tai')" :label-width="formLabelWidth" prop="state">
                  <label v-if="detailForm.state" v-text="detailForm.state.message"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('qiang-lian-jie-zhuang-tai')" :label-width="formLabelWidth" prop="gunConnectionState">
                  <label v-if="detailForm.gunConnectionState"
                         v-text="detailForm.gunConnectionState.message"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('dian-ya')" :label-width="formLabelWidth" prop="voltage">
                  <label v-text="detailForm.voltage"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('dian-liu')" :label-width="formLabelWidth" prop="current">
                  <label v-text="detailForm.current"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('gong-shuai')" :label-width="formLabelWidth" prop="power">
                  <label v-text="detailForm.power"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('dian-liang')" :label-width="formLabelWidth" prop="quantity">
                  <label v-text="detailForm.quantity"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="soc：" :label-width="formLabelWidth" prop="soc">
                  <label v-text="detailForm.soc"></label>
                </el-form-item>
              </el-col>
            </el-collapse-item>
            <el-collapse-item :title="$t('qi-dong-chong-dian-xin-xi')" name="chargingStartInformation">
              <el-col :span="12">
                <el-form-item :label="$t('qi-dong-fang-shi')" :label-width="formLabelWidth" prop="startType">
                  <label v-if="detailForm.stateCode==2&&detailForm.startType ==0">{{ $t('chargingMonitor.SwipeCardActivation') }}</label>
                  <label v-if="detailForm.stateCode==2&&detailForm.startType ==1">{{ $t('chargingMonitor.ScanCodeToStart') }}</label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('ka-hao-shou-ji-hao')" :label-width="formLabelWidth" prop="startNum">
                  <label v-if="detailForm.stateCode==2&&detailForm.startType ==0" v-text="detailForm.cardNo"></label>
                  <label v-if="detailForm.stateCode==2&&detailForm.startType ==1" v-text="detailForm.phone"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('qi-dong-shi-jian')" :label-width="formLabelWidth" prop="startTime">
                  <label v-if="detailForm.stateCode==2" v-text="detailForm.startTime"></label>
                </el-form-item>
              </el-col>
<!--              <el-col :span="12">-->
<!--                <el-form-item label="充电策略：" :label-width="formLabelWidth" prop="chargingType">-->
<!--                  <label v-text="detailForm.chargingType"></label>-->
<!--                </el-form-item>-->
<!--              </el-col>-->
            </el-collapse-item>
            <el-collapse-item :title="$t('bms-xin-xi')" name="BMSInformation">
              <el-col :span="12">
                <el-form-item :label="$t('bms-dian-ya')" :label-width="formLabelWidth" prop="bmsVoltage">
                  <label v-text="detailForm.bmsVoltage"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('bms-dian-liu')" :label-width="formLabelWidth" prop="bmsCurrent">
                  <label v-text="detailForm.bmsCurrent"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('bms-mo-shi')" :label-width="formLabelWidth" prop="bmsPattern">
                  <label v-text="detailForm.bmsPattern"></label>
                </el-form-item>
              </el-col>
            </el-collapse-item>
          </el-collapse>
        </el-form>
      </el-tab-pane>
      <!--          <el-tab-pane label="充电记录" name="chargingRecord"></el-tab-pane>-->
      <!--          <el-tab-pane label="充电报文" name="chargingMessage"></el-tab-pane>-->
    </el-tabs>
  </el-dialog>
</template>

<script>
  export default {
    name: "detail",
    data(){
      return{
        viewName: 'detailForm',
        activeNames: ['basicInformation'],
        formLabelWidth: '150px',
      }
    },
    props:{
      detailFormVisible:false,
      detailForm: {},
    },
    methods:{
      closeDetailForm(){
        this.$emit("closeDetailForm")
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/charginggunManager/detail.vue